import React from "react";
import { Typography } from "@mui/material";

import uploadImg from "assets/images/upload.png";

import { UploadDocument } from "./style";

const UploadImageBackground = () => {
  return (
    <UploadDocument>
      <img style={{ height: "200px", width: "250px" }} src={uploadImg}></img>
      <Typography variant="h5" textAlign="center">
        Upload Here
      </Typography>
    </UploadDocument>
  );
};

export default UploadImageBackground;
